'use strict';

var React = require('react');

var SvgBillingStatementYenMajor = function SvgBillingStatementYenMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0h11c.828 0 1.5.677 1.5 1.512v18.21a.2.2 0 0 1-.334.149l-1.664-1.515a.497.497 0 0 0-.67 0l-1.664 1.514a.497.497 0 0 1-.67 0l-1.663-1.514a.497.497 0 0 0-.67 0l-1.663 1.514a.497.497 0 0 1-.67 0l-1.664-1.514a.497.497 0 0 0-.67 0l-1.664 1.515a.2.2 0 0 1-.334-.15v-18.209c0-.835.672-1.512 1.5-1.512zm7.744 10.523h-1.25v-.75h1.25a.75.75 0 1 0 0-1.5h-.847l1.85-3.204a1 1 0 0 0-1.732-1l-1.515 2.624-1.515-2.624a1 1 0 0 0-1.732 1l1.85 3.204h-.859a.75.75 0 0 0 0 1.5h1.25v.75h-1.25a.75.75 0 1 0 0 1.5h1.25v1a1 1 0 0 0 2 0v-1h1.25a.75.75 0 0 0 0-1.5z"
  }));
};

exports.SvgBillingStatementYenMajor = SvgBillingStatementYenMajor;
